// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"ProductDetails_mainContent__3-w9y","linkContainer":"ProductDetails_linkContainer__1n5df","contactForm":"ProductDetails_contactForm__oG-7u"};